import { inject, InjectionToken } from '@angular/core'

import { ENVIRONMENT } from './environment.token'
import { DEFAULT_FEATURES, FeatureMap } from '../feature-flags/feature-flags.model'

export const FEATURE_FLAGS = new InjectionToken<FeatureMap>('FEATURE_FLAGS', {
  factory: () => {
    const env = inject(ENVIRONMENT, { optional: true })
    return env?.features ?? DEFAULT_FEATURES
  }
})
